<template>
  <btn :class="classes" icon small @click="requestFullscreenToggle">
    <fullscreen-icon />
  </btn>
</template>

<script>
import KeyProcessor from '@/js/KeyProcessor'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'fullscreen-btn',
  computed: {
    ...mapState({ fullscreenEnabled: state => state.video.fullscreen }),
    isExitFullscreenAvailable() {
      return !!document.exitFullscreen
    },
    classes() {
      let classes = [ 'fullscreen' ]

      if (this.fullscreenEnabled) {
        classes.push('active')
      }
      if (this.fullscreenEnabled && !this.isExitFullscreenAvailable) {
        classes.push('hidden')
      }

      return classes.join(' ')
    }
  },
  methods: {
    ...mapActions({ toggleFullscreen: 'video/toggleFullscreen' }),
    requestFullscreenToggle() {
      document.activeElement.blur()
      this.toggleFullscreen()
    }
  },
  mounted() {
    this.keyProcessor = new KeyProcessor({
      70: this.toggleFullscreen
    })
  },
  destroyed() {
    this.keyProcessor.removeListener()
  }
}
</script>

<style lang="scss">
.fullscreen {
  transition: width 0.2s, margin 0.2s;

  &.btn.hidden {
    width: 0;
  }

  svg > path {
    transform-box: fill-box;
    transform-origin: center;
    transition: transform 0.4s;
    transition-delay: 0.6s;
  }

  &.active svg > path {
    transform: rotateZ(180deg);
  }
}
</style>
